import http from "../Services/httpService"
import config from "../config.json"
import * as trackingHelper from "../../helpers/tracking"

export const getData = (query) => {
  return http.get(config.siteprefix + config.url + query)
}

export const createPageData = (data, dataConfig, track = false, eventCategory = "", eventLabel = "") => {
  const displayGroupNames = {}
  var count = 0
  if (data) {
    for (var propName in data) {
      displayGroupNames[propName] = data[propName].displayGroupName
      if (data[propName].count === 0) {
        data[propName].docs = createZeroStateData(data[propName].docs, propName, dataConfig)
        //delete data[propName];
      } else {
        count += data[propName].count
      }
    }
    trackingHelper.handleSearchTrackingTimeout(track, eventCategory, "typeahead - 0.5 sec", eventLabel, count)
    return { filteredData: data, displayGroupNames: displayGroupNames, totalCount: count }
  }
  trackingHelper.handleSearchTrackingTimeout(track, eventCategory, "typeahead - 0.5 sec", eventLabel, count)
  return { filteredData: {}, displayGroupNames: displayGroupNames, totalCount: count }
}

export const createZeroStateData = (docs, propName, dataConfig) => {
  let config = dataConfig
  if (!config) {
    const desktopSearchBox = document.querySelector("[data-input-search]")
    let config = desktopSearchBox ? desktopSearchBox.dataset.inputSearch : ""
    if (config) {
      dataConfig = JSON.parse(config)
    }
  }

  if (docs && docs.length > 0) {
    return docs.map((element) => {
      element.name = config.zeroState.data[propName] ? config.zeroState.data[propName].name : ""
      element.url = config.zeroState.data[propName] ? config.zeroState.data[propName].url : ""
      element.displayGroupName = config.zeroState.data[propName] ? config.zeroState.data[propName].displayGroupName : ""
      return element
    })
  } else {
    // let typeahead = {}
    let zeroDataDocs = []
    if (config.zeroState && config.zeroState.data[propName]) {
      zeroDataDocs = config.zeroState.data[propName].map((element) => {
        element.isZeroData = true
        return element
      })
    }

    docs = zeroDataDocs
    // element.name = config.zeroState.data[propName] ? config.zeroState.data[propName].name : ''
    //   element.url = config.zeroState.data[propName] ? config.zeroState.data[propName].url : ''
    //   element.displayGroupName = config.zeroState.data[propName] ? config.zeroState.data[propName].displayGroupName : ''
    // docs.push(element)
    return docs
  }
}
